export const customFormDataFn = <Body extends Record<string, unknown>>(
  body?: Body,
): FormData => {
  const formData = new FormData();

  Object.entries(body ?? {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;

    if (value instanceof Blob) {
      formData.append(key, value);
    } else if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item instanceof Blob) {
          formData.append(key, item);
        } else {
          formData.append(key, String(item));
        }
      });
    } else {
      formData.append(key, String(value));
    }
  });

  return formData;
};
